import { TimelineScreen } from '@/features/timeline/TimelineScreen'

/**
 * Phase 2: the timeline is the app.
 *
 * The Phase 0/1 diagnostic screen has served its purpose and is gone. What it
 * checked is now visible directly -- if the timeline renders with correct hour
 * labels and a now marker in the right place, the data foundation works.
 */
export default function App() {
  return <TimelineScreen />
}
